export const langRigs = {
  fr: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Détails session',
    rigsDataLink: 'Rigs',
    save: 'Enregistrer ',
    board: 'Board',
    sail: 'Sail',
    sourceFile: `Source : `,
    help: [
      `Vous pouvez indiquer jusqu'à 8 combinaisons de Boards et Wings/Sails par session.`,
      `Pour ajouter une combinaison, cliquez sur +, ajustez les sliders pour indiquer la période à laquelle elle s'applique, puis choisissez le flotteur, l'aile ou la voile dans les listes déroulantes.`,
      `Pour supprimler la dernière combinaison ajoutée, cliquez sur -`,
      `Lorsque vous avez terminé, cliquez sur Enregistrer.`,
      `Les combinaisons figureront en regard du graphe des vitesses dans les stats de la session. Elles seront utilisées pour calculer les Stats d'utilisation des matériels.`,
    ],
    registeredOnly: 'Réservé aux utilisateurs enregistrés',
    alert: `Attention: enregistrer sans rigs indiqués supprimera tous les rigs attachés à la session.`,
  },
  eng: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Session details',
    rigsDataLink: 'Rigs',
    save: 'Save',
    board: 'Board',
    sail: 'Sail/Wing',
    sourceFile: `Source : `,
    help: [
      `You can specify up to 8 combinations of Boards and Wings/Sails per session.`,
      `To add a combination, click +, adjust the sliders to indicate the period to which it applies, then choose the board, wing or sail from the drop-down lists.`,
      `To remove the last added combination, click -`,
      `When you are finished, click Save.`,
      `The combinations will appear next to the speed graph in the session stats. They will be used to calculate Equipment Usage Stats.`,
    ],
    registeredOnly: 'Registered users only',
    alert: `Warning: saving without rigs indicated will delete all rigs attached to the session.`,
  },
}
